import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SlowStock } from 'src/app/models/slow-moving-stock';



@Injectable({
  providedIn: 'root'
})
export class SlowMovingStockService {

  apiUrl = 'v1/slow_moving_stock/';

  constructor(private http: HttpClient) { 
    
  }

  public getSlowStock(description: string = '') {


    return this.http.get( environment.ApiUrl() + this.apiUrl + `order/?description=${description}`);
  }
  
  public createSlowStock(stock: SlowStock) {
    
    return this.http.post( environment.ApiUrl() + this.apiUrl + "order/", stock);
  }
  
  public updateSlowStock(stock: SlowStock) {
    
    return this.http.patch( environment.ApiUrl() + this.apiUrl + `order/${stock.stockId}`, stock);
  }
  
  public removeSlowStock(stockId: number) {
    
    return this.http.delete( environment.ApiUrl() + this.apiUrl + `order/${stockId}`);
  }

  public search(description: string = '') {

    return this.http.get( environment.ApiUrl() + this.apiUrl + `search/?description=${description}`);
  }
}
